<ws-modal-wrapper [headerLabel]="headerLabel" acceptLabel="Save" (save)="save()" (cancel)="cancel()"
                  [disableSave]="!isSaveable()">
    <div class="ws-flex-container-vertical ws-stretch">
        <table class="fb-bulk-update-fields">
            <tbody>
                <tr>
                    <td>
                        <label>Action:</label>
                    </td>
                    <td>
                        <div>
                            <select class="form-select form-select-sm" style="width: auto; display: inline-block;"
                                    [(ngModel)]="editReq.details.editAction" (change)="editActionChanged()">
                                @for (ea of availableEditActions; track ea) {
                                    <option [ngValue]="ea.value">{{ ea.name }}</option>
                                }
                            </select>
                        </div>
                    </td>
                </tr>
                @if (isTaxYearEnabled()) {
                    <tr>
                        <td>
                            <label>Tax Year:</label>
                        </td>
                        <td>
                            <div>
                                <select class="form-select form-select-sm"
                                        style="width: auto; display: inline-block;"
                                        [(ngModel)]="editReq.details.taxYear">
                                    @for (option of selectableTaxYears; track option) {
                                        <option [ngValue]="option">{{ option }}</option>
                                    }
                                </select>
                            </div>
                        </td>
                    </tr>
                }
                @if (isFmvValueEnabled()) {
                    <tr>
                        <td>
                            <label>{{ fmvValueLabel }}:</label>
                        </td>
                        <td>
                            <div>
                                <input type="text"
                                       class="form-control input-number"
                                       style="width: auto; display: inline-block; text-align: right;"
                                       [(ngModel)]="fmvValueDisplay"
                                       (blur)="fmvValueBlur(fmvValueDisplay)">
                            </div>
                        </td>
                    </tr>
                }
                @if (isYoYPercentEnabled()) {
                    <tr>
                        <td>
                            <label>{{ yoyPercentLabel }}:</label>
                        </td>
                        <td>
                            <div>
                                <input type="text"
                                       class="form-control input-number"
                                       style="width: auto; display: inline-block; text-align: right;"
                                       [(ngModel)]="yoyPercentDisplay"
                                       (blur)="yoyPercentBlur(yoyPercentDisplay)">
                            </div>
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
</ws-modal-wrapper>
